import React from 'react';
import { Field } from 'formik';

import RadioField from 'buyside/components/presentation/Form/Field/RadioField/radioField';

import styles from './CoverLetterSectionStyles';

const radioOptions = [
  { label: 'Required', value: 'required' },
  { label: 'Optional', value: 'optional' },
  { label: 'Unwanted', value: 'unwanted' }
];

const CoverLetterSection = () => (
  <div className={styles.container} data-testid="coverLetter">
    <Field component={RadioField} name="coverLetter" options={radioOptions} inColumn />
  </div>
);

export default CoverLetterSection;
